/**
 * Detect the user's country via IP geolocation, with a locale fallback.
 * Returns an ISO 3166-1 alpha-2 code (e.g. "KE", "US") or null.
 */
export async function detectCountry() {
  try {
    const res = await fetch('https://ipapi.co/json/', { signal: AbortSignal.timeout(5000) });
    if (res.ok) {
      const data = await res.json();
      if (data.country_code) return data.country_code.toUpperCase();
    }
  } catch {
    // IP geolocation failed — fall through to locale
  }
  return countryFromLocale();
}

function countryFromLocale() {
  try {
    const locale = navigator.language || navigator.languages?.[0];
    if (!locale) return null;
    const parts = locale.split('-');
    if (parts.length >= 2) {
      const candidate = parts[parts.length - 1].toUpperCase();
      if (candidate.length === 2) return candidate;
    }
  } catch {
    // ignore
  }
  return null;
}
